"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tripReportQuerySchema = void 0;
const zod_1 = require("zod");
exports.tripReportQuerySchema = zod_1.z
    .object({
    date: zod_1.z.string().optional(),
    vehicleId: zod_1.z.string().optional(),
})
    .strict();
